<template lang="pug">
#modelView
  #dwgbox.viewDwg(v-show='hasDwg')
  application(ref="application" type="modelDwg" v-show='hasDwg' key="dwg")
  #modelbox.viewModel(ref="modelbox" v-show='!hasDwg')
  application(ref="application" type="model" v-show='!hasDwg' v-if="modelLoaded" key="model")
</template>

<script>
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import { mongeApp, mongeMutations } from "@/CommonDP/mongeView/store/mongeStore";
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
import application from "@/CommonDP/mongeView/appView/applicationH5.vue";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
import { mapState } from "vuex";

export default {
  components: { application },
  data () {
    return {
      modelLoaded: false,
      // checkContent:'',
      questionId: '',
      flowInstanceId: '',
      shareId: ''
    };
  },
  computed: {
    ...mapState({
      loginUserId: state => state.user.userId
    }),
    mlibEnabled() {
      return mongeApp.mlibEnabled;
    },
    modelInfoData() {
      return JSON.parse(mongeApp.model.fileInfo);
    },
    hasDwg() {
      return mongeApp.model.hasDwg;
    },
    userId() {
      return this.$route.query.userId || this.loginUserId;
    },
    dicList() {
      return mongeApp.dicList;
    },
    // 状态字典
    statusList() {
      return this.dicList?.statusList || [];
    },
    modelMapList() {
      return mongeApp.model.modelMapList;
    }
  },
  watch: {
    $route: {
      // 亲测有效,我是用来监听路由query参数变化
      async handler() {
        this.questionId = this.$route.query.questionId;
        this.flowInstanceId = this.$route.query.flowInstanceId || '';
        this.shareId = this.$route.query.i || '';
        if (!!this.questionId && this.questionId !== "clear") {
          console.log("定位");
          await this.getDicList(this.flowInstanceId);
          await this.getNotationData(this.questionId, this.flowInstanceId, this.shareId);
        }
        // 深度监听，同时也可监听到param参数变化
      },
      deep: true
    }
  },
  created () {
    this.getFileInfo();
  },
  beforeDestroy() {
    mongeMutations.setHasDwg(false);
    mongeMutations.setModelPageFileName();
    mongeMutations.openModelReady(false);
  },
  methods: {
    async getFileInfo() {
      const { fileIds = "", versionIds: rvtVersion = "", questionId = "", i = "", flowInstanceId } = this.$route.query;
      mongeMutations.setShareId(i);
      this.questionId = questionId;
      this.flowInstanceId = flowInstanceId || '';
      this.shareId = i || '';
      if (!fileIds) {
        return Promise.reject("没有文件id，无法获取文件信息");
      }
      const fId = fileIds.split(",");
      const rVersion = rvtVersion.split(",");
      mongeMutations.clearUrlFileIdList();
      if (fId.length === 1) { // 单模型
        const { data } = await mongeService.getFileDetails(fId[0], i);
        document.title = data.fileName;
        const modeldatas = { fileId: data.fileId, fileName: data.fileName, prjId: data.prjId, rvtVersion: rVersion[0], enterpriseId: data.enterpriseId };
        mongeMutations.setModelInfo(JSON.stringify(modeldatas));
      } else { // 多模型
        const fileObj = [];
        let prjId = "";
        let enterpriseId = "";
        for (const [index, value] of fId.entries()) {
          const { data } = await mongeService.getFileDetails(value, i);
          prjId = data.prjId;
          enterpriseId = data.enterpriseId;
          const obj = { folderID: data.fileId, folderName: data.fileName, rvtVersion: rVersion[index] };
          fileObj.push(obj);
        }
        document.title = fileObj.map(e => e.folderName).join();
        const modeldatas = { fileObj, prjId, enterpriseId };
        mongeMutations.setModelInfo(JSON.stringify(modeldatas));
      }
      this.loadModelFromMLib();
    },
    async queryConvertMode() {
      try {
        if (this.modelInfoData.fileObj) { // 多文件
          const modelsArray = this.modelInfoData.fileObj;
          const resList = [];
          for (const iterator of modelsArray) {
            const res = await mongeService.queryConvertMode(iterator.folderID, iterator.rvtVersion);
            resList.push(res.data === 1 ? "new" : "old");
          }
          const mlibEnabled = Array.from(new Set(resList));
          mongeMutations.changeMlibEnabled(mlibEnabled[0] === "new");
          if (mlibEnabled.length > 1) {
            this.$error("新旧模型不能整合");
            setTimeout(() => {
              window.close();
            }, 3000);
          }
        } else if (this.modelInfoData.fileId) {
          const res = await mongeService.queryConvertMode(this.modelInfoData.fileId, this.modelInfoData.rvtVersion || '');
          mongeMutations.changeMlibEnabled(!!(res.data && res.data === 1));
        }
      } catch (e) {
        mongeMutations.changeMlibEnabled(false);
      }
      return Promise.resolve();
    },
    async loadModelFromMLib() {
      await this.queryConvertMode();
      if (this.modelInfoData.fileObj) { // 多文件
        this.multiModels();
      } else if (this.modelInfoData.fileId) { // 单文件
        this.singleModel();
      }
    },
    // 整合模型组装url
    async multiModels() {
      const modelsArray = this.modelInfoData.fileObj;
      let modelUrlInfoList = [];
      if (this.mlibEnabled) {
        for (const item of modelsArray) {
          const rvtId = item.folderID;
          const rvtVersion = item.rvtVersion || "";
          try {
            const res = await mongeService.queryModelLightFilesFromMLib(rvtId, rvtVersion);
            let modelUrlInfoList = mongeApiMlib.dealMongeModelFiles(res.data);
            const obj = { fileId: rvtId, rvtVersion, url: modelUrlInfoList };
            mongeMutations.setUrlFileIdList(obj);
            modelUrlInfoList = [...modelUrlInfoList, ...list];
          } catch (error) {
            this.$error("未获取模型id");
          }
        }
        this.loadModel(modelUrlInfoList);
      } else {
        for (const item of modelsArray) {
          const rvtId = item.folderID;
          const rvtVersion = item.rvtVersion || "";
          try {
            const res = await mongeService.queryModelUrlList(rvtId, rvtVersion);
            const list = mongeApiMlib.assembleModelUrl(res.data);
            const obj = { fileId: rvtId, rvtVersion, url: list };
            mongeMutations.setUrlFileIdList(obj);
            modelUrlInfoList = [...modelUrlInfoList, ...list];
          } catch (error) {
            this.$error("未获取模型id");
          }
        }
        this.loadModel(modelUrlInfoList);
      }
    },
    // 单模型组装url
    async singleModel() {
      const rvtId = this.modelInfoData.fileId;
      const rvtVersion = this.modelInfoData.rvtVersion || "";
      try {
        if (this.mlibEnabled) {
          const res = await mongeService.queryModelLightFilesFromMLib(rvtId, rvtVersion);
          const modelUrlInfoList = mongeApiMlib.dealMongeModelFiles(res.data);
          const obj = { fileId: rvtId, rvtVersion, url: modelUrlInfoList };
          mongeMutations.setUrlFileIdList(obj);
          this.loadModel(modelUrlInfoList);
        } else {
          const res = await mongeService.queryModelUrlList(rvtId, rvtVersion);
          const modelUrlInfoList = mongeApiMlib.assembleModelUrl(res.data);
          const obj = { fileId: rvtId, rvtVersion, url: modelUrlInfoList };
          mongeMutations.setUrlFileIdList(obj);
          this.loadModel(modelUrlInfoList);
        }
      } catch (error) {
        this.$error("未获取模型id");
      }
    },
    // 加载模型
    async loadModel(urlList) {
      await mongeApiMlib.loadModel(urlList, "modelbox", true);
      this.modelLoaded = true;
    },
    onContextmenu(event) {
      mongeApiMlib.onContextmenu(event);
    },
    resize() {
      mongeApiMlib.resize();
    },
    async closeMap() {
      mongeMutations.setHasDwg(false);
      mongeMutations.setModelPageFileName();
      mongeApiMlib.closeMap();
    },
    async getDicList(flowInstanceId) {
      mongeCommon.getDicList(this.modelInfoData.prjId, flowInstanceId);
    },
    async getNotationData(val, flowInstanceId, shareId) {
      mongeCommon.getNotationData(val, this.userId, "model", flowInstanceId, shareId);
    }
  }
};
</script>

<style lang="scss" scoped>
#modelView{
  height: 100vh;
  width: 100%;
  position: relative;
  user-select: none;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: row;
  // .view{
  //   position: absolute;
  //   width: 100vw;
  //   height: 100%;
  // }
  // .loadStyle{
  //   top: 46px;
  //   height: calc(100% - 46px);
  // }
  #modelbox,#dwgbox{
    position: absolute;
    top: 44px;
    width: 100vw;
    height: calc(100% - 44px);
  }

}
</style>
